export default __webpack_public_path__ + "static/media/beep.e7a699a4.mp3";